import { format, isToday, isSameDay } from 'date-fns';
import { Message } from '../type';
import { Box, Typography } from '@mui/material';
import { useIntl } from 'react-intl';

type MessageDividerProps = {
  message: Message;
  previousMessage?: Message;
};

export const MessageDivider = (props: MessageDividerProps) => {
  const { message, previousMessage } = props;
  const intl = useIntl();
  const createdDate = message.createdDate.toDate();
  const previousMessageCreatedDate = previousMessage?.createdDate?.toDate();

  if (
    previousMessageCreatedDate &&
    isSameDay(createdDate, previousMessageCreatedDate)
  ) {
    return null;
  }

  const text = isToday(createdDate)
    ? intl.formatMessage({ id: 'common.today' })
    : format(createdDate, 'MM/dd/yy');
  return (
    <Box
      component='li'
      sx={{ display: 'flex', justifyContent: 'center', my: 10 }}
    >
      <Typography
        sx={{
          px: 5,
          py: 1,
          borderRadius: 3.25,
          bgcolor: '#898f9b',
          fontSize: 12,
          color: 'white',
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};
